var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.15 26.44a.75.75 0 0 1-.75-.75V16.1a13 13 0 0 0-4-9.42 13.64 13.64 0 0 0-23.2 9.42v9.59a.75.75 0 0 1-1.5 0V16.1A15.14 15.14 0 0 1 71.47 5.61 14.48 14.48 0 0 1 75.9 16.1v9.59a.74.74 0 0 1-.75.75Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.57 98.75H22.75a10.1 10.1 0 0 1-10.17-10V30a5.1 5.1 0 0 1 5.14-5.07h52.62a.76.76 0 0 1 .75.75v62.63a8.76 8.76 0 0 0 2.66 6.31 9.13 9.13 0 0 0 5.86 2.6.75.75 0 0 1 .71.75.76.76 0 0 1-.75.78ZM17.72 26.44A3.61 3.61 0 0 0 14.08 30v58.74a8.6 8.6 0 0 0 8.67 8.51h52a10.33 10.33 0 0 1-2-1.56 10.22 10.22 0 0 1-3.12-7.38V26.44Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.74 40.66a.74.74 0 0 1-.75-.75V16.1a13.61 13.61 0 0 0-27.21 0v23.81a.75.75 0 0 1-1.5 0V16.1a15.11 15.11 0 0 1 30.21 0v23.81a.75.75 0 0 1-.75.75ZM41.76 77.55a.69.69 0 0 1-.37-.1l-12.83-7.4a.74.74 0 0 1-.37-.65V54.6a.74.74 0 0 1 .37-.65l12.83-7.41a.77.77 0 0 1 .75 0L55 54a.75.75 0 0 1 .38.65V69.4a.75.75 0 0 1-.38.65l-12.82 7.4a.75.75 0 0 1-.42.1ZM29.69 69l12.07 7 12.08-7V55l-12.08-7-12.07 7Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.76 62.75a.79.79 0 0 1-.37-.1l-12.83-7.41a.75.75 0 0 1 0-1.29l12.83-7.41a.77.77 0 0 1 .75 0L55 54a.74.74 0 0 1 0 1.29l-12.86 7.36a.86.86 0 0 1-.38.1ZM30.44 54.6l11.32 6.53 11.33-6.53-11.33-6.54Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.76 77.16a.75.75 0 0 1-.75-.75V62a.75.75 0 0 1 1.5 0v14.41a.74.74 0 0 1-.75.75ZM90.83 30v58.3a10.54 10.54 0 0 1-10.62 10.45 4.65 4.65 0 0 1-.75 0 10.47 10.47 0 0 1-6.75-3 10.22 10.22 0 0 1-3.12-7.38V25.69a.75.75 0 0 1 .75-.75h15.35A5.11 5.11 0 0 1 90.83 30Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping_bag.1f0bbd993f428de6cae063080b616a9c.svg";
export { ForwardRef as ReactComponent };